const A = '/brand';

export const VEHICLES = [
  { id: 'sedan', title: 'Sedan', meta: 'M3 · C-Class · Model 3', image: `${A}/frozen-m3.jpg`, mult: 1, recommendation: 'Full Front Daily', ppf: 'full-front' },
  { id: 'suv', title: 'SUV', meta: 'X5 · G-Wagon · Model Y', image: `${A}/gwagon.jpg`, mult: 1.14, recommendation: 'Ottawa All-Season', ppf: 'supremex' },
  { id: 'truck', title: 'Truck', meta: 'F-150 · R1T · Sierra', image: `${A}/p7.jpg`, mult: 1.2, recommendation: 'High-Impact Coverage', ppf: 'supremex' },
  { id: 'tesla', title: 'Tesla', meta: 'Model 3 · Y · S · X', image: `${A}/tesla-gold.jpg`, mult: 1.08, recommendation: 'Delivery-Day Protection', ppf: 'full-front' },
  { id: 'exotic', title: 'Exotic', meta: '911 · Vantage · Huracán', image: `${A}/aston.jpg`, mult: 1.32, recommendation: 'Maximum Preservation', ppf: 'full' },
];

export const DRIVE_PROFILES = [
  { id: 'city', title: 'City daily', meta: 'Parking, construction and year-round use', ppf: 'full-front', tint: 'xr', ceramic: 'c2', correction: 'none' },
  { id: 'highway', title: 'Highway', meta: 'Frequent 417 runs and higher chip exposure', ppf: 'supremex', tint: 'xr-plus', ceramic: 'c4', correction: 'none' },
  { id: 'new', title: 'New car', meta: 'Protect the finish before daily wear begins', ppf: 'full-front', tint: 'xr-plus', ceramic: 'c4', correction: 'none' },
  { id: 'weekend', title: 'Weekend', meta: 'Low mileage, high attention to finish', ppf: 'partial-bumper', tint: 'none', ceramic: 'c4', correction: 'p1' },
  { id: 'maximum', title: 'Maximum', meta: 'Preservation-first, complete exterior coverage', ppf: 'full', tint: 'xr-plus', ceramic: 'c8', correction: 'p1' },
];

export const PPF_OPTIONS = [
  { id: 'partial', n: '01', title: 'Partial Coverage', price: 449.99, studioDays: 'Same day', body: 'Partial hood and fenders for the first impact zone.', zones: ['hoodFront', 'fenderL', 'fenderR'] },
  { id: 'partial-bumper', n: '02', title: 'Partial + Bumper', price: 949.99, studioDays: '1 day', body: 'Adds the front bumper to the partial protection package.', zones: ['frontBumper', 'hoodFront', 'fenderL', 'fenderR', 'mirrorL', 'mirrorR'] },
  { id: 'full-front', n: '03', title: 'Full Front', price: 1749.99, studioDays: '1–2 days', body: 'Bumper, full hood, fenders and mirrors for daily drivers.', zones: ['frontBumper', 'hoodFront', 'hood', 'fenderL', 'fenderR', 'mirrorL', 'mirrorR'] },
  { id: 'supremex', n: '04', title: 'SupremeX Coverage', price: 2749.99, studioDays: '2–3 days', body: 'Full front plus rockers and leading roof edge for highway exposure.', zones: ['frontBumper', 'hoodFront', 'hood', 'fenderL', 'fenderR', 'mirrorL', 'mirrorR', 'rockerL', 'rockerR', 'roofFront'] },
  { id: 'full', n: '05', title: 'Full Vehicle', price: 4999.99, studioDays: '4–5 days', body: 'Every painted panel protected for maximum preservation.', zones: ['frontBumper', 'hoodFront', 'hood', 'fenderL', 'fenderR', 'mirrorL', 'mirrorR', 'rockerL', 'rockerR', 'roofFront', 'roof', 'doorL', 'doorR', 'quarterL', 'quarterR', 'rearBumper', 'trunk'] },
];

export const ADD_ONS = {
  tint: [
    { id: 'none', title: 'No tint', body: 'Keep factory glass', price: 0 },
    { id: 'xr', title: 'PRIME XR', body: 'Ceramic sides + rear', price: 449 },
    { id: 'xr-plus', title: 'PRIME XR PLUS', body: 'Premium ceramic sides + rear', price: 649 },
    { id: 'xr-ws', title: 'XR PLUS + windshield', body: 'Full glass package', price: 999 },
  ],
  ceramic: [
    { id: 'none', title: 'No coating', body: 'Skip coating for now', price: 0 },
    { id: 'c2', title: 'FUSION PLUS / 2-year', body: 'Paint + wheel faces', price: 899 },
    { id: 'c4', title: 'FUSION PLUS / 4-year', body: 'Paint, wheels, glass and trim', price: 1499 },
    { id: 'c8', title: 'FUSION PLUS / 8-year', body: 'Full exterior + interior', price: 2299 },
  ],
  correction: [
    { id: 'none', title: 'New / clean finish', body: 'No correction allowance', price: 0 },
    { id: 'p1', title: '1-step enhancement', body: 'Light swirl removal and gloss', price: 549 },
    { id: 'p2', title: '2-step correction', body: 'Compound and polish', price: 1099 },
  ],
};

export const PROTECTION_STAGES = [
  { id: 'impact', n: '01', title: 'Impact', kicker: 'The road hits first', body: 'XPEL paint protection film takes the chips, salt and debris before your clear coat does.', image: `${A}/x3-ppf.jpg`, color: '#e50d0d', label: 'PPF · impact zones' },
  { id: 'surface', n: '02', title: 'Surface', kicker: 'Gloss stays easier', body: 'A ceramic layer makes contamination release faster while preserving a deep, finished surface.', image: `${A}/fusion-ceramic.jpg`, color: '#4d8dff', label: 'Ceramic · finish layer' },
  { id: 'cabin', n: '03', title: 'Cabin', kicker: 'Heat stays outside', body: 'Ceramic window film reduces solar load and protects the interior without turning the view murky.', image: `${A}/bmw-tint.jpg`, color: '#f2a428', label: 'Tint · glass system' },
];

export const INSPECTION_MODES = [
  { id: 'paint', title: 'Paint', before: 'Swirls + haze', after: 'Corrected clarity', image: `${A}/m3-white.jpg`, filterBefore: 'saturate(.55) contrast(.8) brightness(.82)', filterAfter: 'saturate(1.15) contrast(1.07)' },
  { id: 'ppf', title: 'PPF', before: 'Exposed impact zone', after: 'Protected finish', image: `${A}/frozen-m3.jpg`, filterBefore: 'contrast(1.04) brightness(.8)', filterAfter: 'contrast(1.08) brightness(1.05)' },
  { id: 'tint', title: 'Tint', before: 'Open solar load', after: 'Ceramic-filtered cabin', image: `${A}/bmw-tint.jpg`, filterBefore: 'brightness(1.23) saturate(.75)', filterAfter: 'brightness(.78) saturate(1.08)' },
];

export const findById = (list, id, fallback = 0) => list.find((item) => item.id === id) || list[fallback];
export const formatMoney = (n, cents = false) => new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: cents ? 2 : 0 }).format(n);

export function calculateBuild(config) {
  const vehicle = findById(VEHICLES, config.vehicle);
  const ppf = findById(PPF_OPTIONS, config.ppf, 2);
  const selected = ['tint', 'ceramic', 'correction'].map((group) => {
    const option = findById(ADD_ONS[group], config[group]);
    return { group, ...option, calculatedPrice: Math.round(option.price * vehicle.mult) };
  });
  const base = ppf.price + selected.reduce((sum, option) => sum + option.calculatedPrice, 0);
  const combined = selected.some((option) => option.price > 0);
  const lower = Math.round(base / 10) * 10;
  const upper = Math.round((base * (combined ? 1.12 : 1)) / 10) * 10;
  const impact = [35, 48, 68, 84, 100][PPF_OPTIONS.findIndex((item) => item.id === ppf.id)];
  const tint = findById(ADD_ONS.tint, config.tint);
  const ceramic = findById(ADD_ONS.ceramic, config.ceramic);
  const correction = findById(ADD_ONS.correction, config.correction);
  const scores = {
    impact,
    surface: Math.min(100, 24 + (ceramic.price ? 46 : 0) + (correction.price ? 18 : 0)),
    cabin: tint.price ? (tint.id === 'xr' ? 68 : tint.id === 'xr-plus' ? 84 : 94) : 25,
  };
  scores.overall = Math.round((scores.impact + scores.surface + scores.cabin) / 3);
  return { vehicle, ppf, selected, lower, upper, combined, scores };
}

export const buildQuery = (values) => {
  const params = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => value && params.set(key, value));
  return `/build?${params.toString()}`;
};

export const DEFAULT_BUILD = { vehicle: 'sedan', profile: 'new', ppf: 'full-front', tint: 'xr-plus', ceramic: 'c4', correction: 'none' };

